
import { defineComponent } from 'vue';
import { UPLOAD_SIZE_STRING, _Util } from '@/MyUtil';
import * as _ from 'lodash';
import { _ServerApi } from '@/serverAPI';
import 'md-editor-v3/lib/style.css';
import MdEditor from 'md-editor-v3';


export default defineComponent({
  name: 'BoardView',
  data() {
    return {
      "util" : _Util.getInstance(),
      "title" : "",
      "cont" : "",
      "windowWidth": window.innerWidth,
      "is_my_board" :false,
      "url_key" : "",

    }
  },
  components: {
    "md-editor-v3": MdEditor
  },
  computed:{
    isEditorDesktop(){
      if(this.windowWidth >= 1024){
        return true;
      }
      return false;
    }
  },
  methods: {
    add_noti(msg:string){
      this.util.add_noti({
        vue_ele : this.$root,
        msg : msg,
      });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      //console.log(this.windowWidth);
    },
    async deleteBoard(){
      if(!confirm("해당 내용을 삭제 하시겠습니까?")){
        return;
      }
      const _api = _ServerApi.getInstance();
      const result = await _api.postJson("/api/delBoard",{
        "url_key" : this.url_key,
      });
      if(result.isError){
        this.add_noti(result.msg);
        return;
      }
      window.close();
    },
    reWriteBoard(){
      this.$router.push(`/BoardWrite?url_key=${this.url_key}`)
    },


  },
  async mounted() {
    window.addEventListener('resize', this.onResize);
    console.log("Test");
    //전체사이즈로 셋팅
    this.util.setFullSize({
      vue_ele:this.$root,
      is_full : true,

    });

    const params = this.$route.params;
    let url_key = params.url_key;
    if(!_.isString(url_key)){
      url_key = "";
    }
    this.url_key = url_key;

    const url = "/api/getBoardView";
    console.log(params);
    const _api = _ServerApi.getInstance();
    const result = await _api.postJson(url,{"url_key" : url_key});
    if(result.isError){
      this.title = "오류가 발생했습니다.";
      this.cont = result.msg;
      return;
    }

    const doc = result.doc;
    const title =doc.title;
    const cont = doc.cont;
    const desc = doc.sub_title;
    const main_img = doc.main_img;

    this.is_my_board = result.is_my_board;
    this.title = title;
    this.cont = cont;
    const setting = this.util.getSetting();
    const img_full_url = this.util.getImgURL(main_img,UPLOAD_SIZE_STRING.S_800X400);
    this.util.setMeta({
      url : setting.WEB_Site_URL + this.$route.path,
      desc : desc,
      image : img_full_url,
      title : title,
    });
    //useMeta(meta);
  },
  unmounted() {
    
    window.removeEventListener('resize', this.onResize); 
  },

});
